import { Link } from "react-router-dom";
import { PageHero } from "@/components/PageHero";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { IMG } from "@/data/site";

const experiences = [
  { title: "Signature Breakfast", time: "07:00 – 10:00", text: "A generous buffet of tropical fruits, fresh-baked breads, Swahili classics like mandazi and mchemsho, plus a live egg station. Included with every stay.", image: IMG.breakfast },
  { title: "À La Carte Lunch & Dinner", time: "12:00 – 22:30", text: "Coastal seafood, grilled specialties and international favourites — every dish plated with intention by our kitchen brigade.", image: IMG.beachPavilion2 },
  { title: "Special Dining Experiences", time: "By reservation", text: "Private candlelit dinners by the pool, garden wine tastings with fresh island fruit, and celebration cakes crafted to order. Email reservations to arrange something unforgettable.", image: IMG.wineTable },
];

export default function Restaurant() {
  return (
    <div data-testid="restaurant-page">
      <PageHero overline="Dining" title="The Restaurant" subtitle="Barefoot beach dining under a makuti roof — Swahili flavours, ocean air." image={IMG.restaurantPavilion} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12 space-y-20">
        {experiences.map((exp, i) => (
          <FadeUp key={exp.title}>
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
              <div className="img-zoom aspect-[16/10] [direction:ltr]">
                <img src={exp.image} alt={exp.title} className="w-full h-full object-cover" />
              </div>
              <div className="[direction:ltr]">
                <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-3">{exp.time}</p>
                <h2 className="font-serif-display text-3xl md:text-4xl font-light text-white">{exp.title}</h2>
                <p className="mt-5 text-[#a3a3a3] leading-relaxed max-w-lg">{exp.text}</p>
              </div>
            </div>
          </FadeUp>
        ))}
        <Stagger className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t hairline">
          {[["Breakfast Menu", "Fruits, pastries, Swahili classics & live stations"], ["Dietary Needs", "Vegetarian, vegan, halal & allergy-aware kitchen"], ["Private Dining", "Poolside dinners & chef's table by reservation"]].map(([t, d]) => (
            <StaggerItem key={t} className="p-6 border hairline">
              <h3 className="font-serif-display text-xl text-white">{t}</h3>
              <p className="text-sm text-[#a3a3a3] mt-2">{d}</p>
            </StaggerItem>
          ))}
        </Stagger>
        <FadeUp>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center pt-8 border-t hairline">
            <div className="img-zoom aspect-[16/10]">
              <img src={IMG.baobabBar} alt="Baobab Bar" className="w-full h-full object-cover" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-3">Open Daily · 10:00 – 23:00</p>
              <h2 className="font-serif-display text-3xl md:text-4xl font-light text-white">The Baobab Bar</h2>
              <p className="mt-5 text-[#a3a3a3] leading-relaxed max-w-lg">
                Under the shade of the ancient baobab, our beach bar pours fresh island juices, signature cocktails and BBQ &amp; grill favourites — toes in the sand, ocean in view.
              </p>
              <Link to="/bar-lounge" className="btn-gold mt-8 inline-block px-8 py-4 text-[12px] tracking-[0.2em] uppercase font-semibold" data-testid="restaurant-bar-link">Visit the Baobab Bar</Link>
            </div>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
